'use strict';

import ngResource from 'angular-resource';

class WeatherService {
  constructor($resource) {
    'ngInject';

    this.api = $resource(
      '/api/weather',
      {},
      { index: {method: 'GET', isArray: true} }
    );
  }
}

export default angular.module('leptonApp.WeatherService', ['ngResource'])
  .service('WeatherService', ['$resource', WeatherService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/weather/weather.service.js